import React from 'react'
import classnames from 'classnames/bind'
import { OnlineAuctionSegment } from '@adc/sdk/types'
import { bidding } from '@adc/blueprint'
import cls from './styles.scss'

const cx = classnames.bind(cls)

type OfferChartProps = {
  segment?: OnlineAuctionSegment
}

type ChartProps = {
  mainColor: string
  secondColor: string
  thirdColor: string
  secondOpacity: string
  thirdOpacity: string
}

const ChartAreaIcon: React.FC<ChartProps> = ({
  mainColor,
  secondColor,
  thirdColor,
  secondOpacity,
  thirdOpacity,
}) => (
  <svg
    width='242'
    height='82'
    viewBox='0 0 242 82'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      id='Vector 2'
      d='M7.38706 74.8953C4.07766 75.6058 1.08344 79.9278 0 82H242V0H211.861C209.497 0 206.936 1.77618 205.951 2.66427C198.761 9.76898 183.967 24.452 182.313 26.3466C180.658 28.2412 177.683 29.1093 176.403 29.3064C165.076 29.2078 141.891 29.0696 139.763 29.3064C137.636 29.5433 135.331 31.3787 134.444 32.2667C131.194 35.4244 124.221 42.2725 122.33 44.404C120.439 46.5354 118.587 47.2656 117.897 47.3643H82.735C79.8984 47.3643 77.8103 48.9431 77.1209 49.7325C70.5218 56.4425 56.7917 70.3362 54.6642 72.2307C52.5368 74.1253 51.2169 74.7965 50.823 74.8953C37.7232 74.5993 10.6965 74.1848 7.38706 74.8953Z'
      fill='url(#paint0_linear_3656_13593)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_3656_13593'
        x1='121.148'
        y1='-3.35913e-08'
        x2='120.999'
        y2='82'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor={mainColor} stopOpacity='0.3' />
        <stop
          offset='0.523806'
          stopColor={secondColor}
          stopOpacity={secondOpacity}
        />
        <stop
          offset='0.861443'
          stopColor={thirdColor}
          stopOpacity={thirdOpacity}
        />
        <stop offset='1' stopColor='#F0FBFE' stopOpacity='0' />
      </linearGradient>
    </defs>
  </svg>
)

const ChartLineIcon: React.FC<ChartProps> = ({ mainColor }) => (
  <svg
    className='chart-line'
    width='189'
    height='74'
    viewBox='0 0 189 74'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      id='Vector 3'
      d='M1 73C3.13502 71.1115 16.9138 57.2622 23.5363 50.5736C24.2282 49.7867 26.3237 48.2129 29.1703 48.2129C32.017 48.2129 53.8812 48.2129 64.4574 48.2129C65.1493 48.1146 67.0076 47.3867 68.9054 45.2621C70.8032 43.1375 77.8013 36.3112 81.0631 33.1637C81.9527 32.2784 84.2656 30.4489 86.4006 30.2128C88.5356 29.9768 111.803 30.1145 123.17 30.2128C124.455 30.0163 127.44 29.151 129.101 27.2625C130.762 25.3739 145.608 10.7378 152.823 3.65576C153.812 2.7705 156.382 1 158.754 1C161.126 1 179.906 1 189 1'
      stroke={mainColor}
      strokeWidth='2'
    />
  </svg>
)

const offerChart = ({ segment }: OfferChartProps) => {
  const colors = (
    segment && bidding.utils.onlineAuctionUtils.isHighestAndBestRound(segment)
      ? {
          mainColor: '#6A277A',
          secondColor: '#6A277A',
          thirdColor: '#6A277A',
          secondOpacity: '0.2',
          thirdOpacity: '0.05',
        }
      : {
          mainColor: '#57C1E8',
          secondColor: '#6FCAEC',
          thirdColor: '#B6E5F6',
          secondOpacity: '0.3',
          thirdOpacity: '0.136378',
        }
  ) as ChartProps

  return (
    <div className={cx('container')}>
      <ChartAreaIcon {...colors} />
      <ChartLineIcon {...colors} />
    </div>
  )
}

export default offerChart
